import { styled, theme } from '@/src/stitches.config'

export const Message = styled('div', {
    display: 'none',
    width: 'max-content',
    '@md': {
        fontWeight: 'bold',
        display: 'flex',
        borderRight: '$shadowDark 1px solid',
        px: '30px',
        fontSize: '$2',
        textAlign: 'right',
    },
    '@lg': {
        fontSize: '$4',
        mr: '25px',
    },
})
export const Steps = styled('div', {
    display: 'none',
    '@md': {
        display: 'flex',
        position: 'relative',
        fd: 'row',
        jc: 'space-between',
        width: 'max-content',
        maxWidth: '56%',
    },
})
export const CircleWrapper = styled('div', {
    mt: '10px',
    mx: '10px',
    display: 'flex',
    fd: 'column',
    ai: 'center',
    width: '120px',
    maxWidth: '30%',
    '& p': {
        fontSize: '$1',
        textAlign: 'center',
        my: '6px',
    },
    '@lg': {
        '& p': {
            fontSize: '$2',
        },
    },
})
export const Circle = styled('div', {
    br: '50%',
    border: '$shadowDark 2px solid',
    display: 'flex',
    jc: 'flex-start',
    ai: 'center',
    width: '34px',
    height: '34px',
    background: '$white',
    fontSize: '13px',
    '& p': {
        margin: 0,
        height: '100%',
        width: '100%',
        pt: '19.5%',
        br: '50%',
        fontSize: '15px',
        border: 'white 1px solid',
    },
})
export const CircleText = styled('p', {
    color: '$mediumGray',
})
export const Line = styled('div', {
    top: '39%',
    left: '13%',
    zIndex: '-1',
    width: '72%',
    height: '4px',
    background: '$shadowDark',
    position: 'absolute',
})

export const styles = {
    currentStep: {
        color: 'white',
        background: `-webkit-linear-gradient(top right, ${theme.colors.secondary} 20%, ${theme.colors.primary} 74%)`,
        boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25',
    },
    stepComplete: {
        background: `${theme.colors.secondary}`,
        color: 'white',
        fontSize: '14px',
    },
    currentStepText: {
        color: theme.colors.secondary,
        fontWeight: 'bold',
    },
    completedStepText: {
        color: theme.colors.dark,
    },
}
